import { ref } from 'vue';
import { useYupValidation } from '@future-harry/nxt-styles';
import { applyToPosition } from '../../../core/collections/positions/positions.service';
import { getApplySchema } from '../components/modals/apply/apply.schema';
import type { ApplyFormModel } from '../components/modals/apply/apply.model';
import type { ApplicationFields } from '@/core/collections/job-boards/job-board.interface';

export function usePositionApplication(form: any, applicationFields: ApplicationFields) {
   const isSubmitting = ref(false);
   const isSuccess = ref<boolean | null>(null); // null = not submitted yet

   const applySchema = getApplySchema(applicationFields);
   const { errors, validate } = useYupValidation({ schema: applySchema, data: form });

   async function submit(positionId: string, formData: ApplyFormModel) {
      isSuccess.value = null;

      const res = validate();
      if (!res.isValid) return false;

      isSubmitting.value = true;
      try {
         await applyToPosition(positionId, formData, applicationFields);
         isSuccess.value = true;
         return true;
      } catch (err: any) {
         // transform and set API errors to match error format
         // ex. date_of_birth : ['Date of birth moet een datum voor 2026-02-02 zijn.']
         //     to date_of_birth : 'Date of birth moet een datum voor 2026-02-02 zijn.'
         const apiErrors = err.response?.data?.errors;
         if (apiErrors) {
            errors.value = Object.entries(apiErrors).reduce(
               (acc, item) => {
                  const [key, value]: [string, any] = item;
                  acc[key] = value[0];
                  return acc;
               },
               {} as Record<string, string>,
            );
         } else {
            isSuccess.value = false;
         }

         return false;
      } finally {
         isSubmitting.value = false;
      }
   }

   return {
      isSubmitting,
      isSuccess,
      errors,
      submit,
   };
}
